import { TbParking } from 'react-icons/tb'

import { TopMenu } from '../Components/TopMenu'
import { DICTIONARY_SEARCH_FIELDS } from '../Contracts/DictionaryFields'
import { CRM_LIST_COLUMNS, crmListFields } from '../Contracts/CrmListFields'
import { CheckDictionaryPageAccessTask } from '../Tasks/CheckDictionaryPageAccessTask'

import type { IResourceConfig } from '@/Core/Contracts/UI'

/**
 * Довідник «Кількість транспортних засобів у парку» (сім'я `CrmList`, `SPEC-007` §4).
 *
 * Розмір автопарку перевізника.
 *
 * Сторінку бачить лише той, кому бек дає створення довідників, тобто
 * адміністратор (`pageConfig.accessFn`, `SPEC-007` §7.1); читати довідник для
 * селектів може кожен.
 */
export const ListCarParkSizeResource: IResourceConfig = {
    title: 'Кількість транспортних засобів у парку',
    fields: crmListFields(),
    table: {
        showColumns: CRM_LIST_COLUMNS,
    },
    filter: {
        includeFields: ['id', 'title'],
    },
    places: {
        top: <TopMenu current="car-park-sizes" />,
    },
    restUrl: '/services/car_park_sizes',
    pageUrl: '/settings/car-park-sizes',
    pageConfig: {
        title: 'Кількість транспортних засобів у парку',
        icon: <TbParking />,
        accessFn: CheckDictionaryPageAccessTask,
    },
    settings: {
        searchFields: DICTIONARY_SEARCH_FIELDS,
    },
}
